import { useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { MainLayout } from "../Layout";
import AllowedAccess from "../Layout/AllowedAccess";
import ErrorBoundry from "../Services/ErrorBoundry";
import Notifications from "../Modules/Notifications";
import ResetPassword from "../Modules/ResetPassword";
import Dashboard from "../Modules/Dashboard";
import PageNotFound from "../Modules/pageNoFound";

import { useEffect } from "react";
import MembersRoutes from "../Modules/members";
import MasterRoutes from "../Modules/master";
import Profile from "../Modules/Profile";
import EventsRoutes from "../Modules/events";
import AssignRoles from "../Modules/assign-roles/AssignRoles";
import DivisionTransferRoutes from "../Modules/division-transfer";
import PaymentsRoutes from "../Modules/payments";
import SurveyRoutes from "../Modules/survey";
import CollectionsRoutes from "../Modules/collections";
import TakhmeenRoutes from "../Modules/takhmeen";
import ReportsRoutes from "../Modules/reports";
import WhatsappRoutes from "../Modules/whatsapp";

const LoginToHome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    navigate('/');
  }, [location.pathname]);
  return <></>;
}
const AppRoutes = () => {
  const { userData } = useSelector((state) => state.user);
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route path="/" element={<Dashboard />} />
        {/* <Route
          path="/supplier-registration"
          element={
            <AllowedAccess
              role={userData.role_slug}
              allowedRoles={["supplier_plant_officer"]}
              renderNoAccess={() => <ErrorBoundry />}
              children={<Registration />}
            />
          }
        /> */}
        
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        
        {/* <Route
          path="/reports/*"
          element={<ReportsRoutes capabilities={userData.capabilities} />}
        />
        
        {
          (userData.capabilities.includes('upload_eloi') || userData.capabilities.includes('view_eloi_supplier_documents') || (userData.user_role === 'supplier_plant_officer' && !userData.limited_access)) &&
          <Route path="/eloi/*" element={<ELoiRoutes capabilities={userData.capabilities} user_role={userData.user_role} />} />
        } */}
        {
          <Route path="/members/*" element={<MembersRoutes />} />
        }
          <Route path="/events/*" element={<EventsRoutes />} />
          <Route path="/survey/*" element={<SurveyRoutes />} />
          <Route path="/collections/*" element={<CollectionsRoutes />} />
          <Route path="/takhmeen/*" element={<TakhmeenRoutes />} />
        {
          userData.role_slug === "super_admin" && 
          <Route path="/master/*" element={<MasterRoutes />} />
        }
        <Route path="/assign-roles" element={<AssignRoles />} />
        <Route path="/reports/*" element={<ReportsRoutes />} />
        <Route path="/division-transfer/*" element={<DivisionTransferRoutes />} />
        <Route path="/payments/*" element={<PaymentsRoutes />} />
        <Route path="/whatsapp/*" element={<WhatsappRoutes />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="/login" element={<LoginToHome />} />

    </Routes>
  );
};
export default AppRoutes;
